export default __webpack_public_path__ + "static/agri-88e8b6cd59dcebc08664fb679df48618.jpg";